// extracted by mini-css-extract-plugin
export default {"navigationBarV2LeftItem":"VFMyTests_navigationBarV2LeftItem__KWC2t","tableHeaderCounterTitle":"VFMyTests_tableHeaderCounterTitle__cB47G"};